import React, { Fragment, useEffect, useState } from 'react';
import { Grid } from "@material-ui/core";
import { MaskedNumber } from "./";

const Duration = props => {
  const [state, setState] = useState({    
    hours: parseInt((props.value||0)/60)?parseInt((props.value||0)/60):undefined,
    minutes: parseInt((props.value||0) % 60)?parseInt((props.value||0) % 60):undefined,
    duration: props.value,
    oldValue: props.value
  });

  useEffect(()=> {
    if (props.value !== state.oldValue) {
      setState({
        hours: parseInt((props.value||0)/60)?parseInt((props.value||0)/60):undefined,
        minutes: parseInt((props.value||0) % 60)?parseInt((props.value||0) % 60):undefined,
        duration: props.value,
        oldValue: props.value
      });
    }
  }, [props.value, state.oldValue])

  const handleHoursChange = (value) => {
    let hours = parseInt(value||0);
    let minutes = (state.minutes || 0);
    let duration = hours * 60 + minutes;
    if (hours === 0) hours = undefined;
    if (minutes === 0) minutes = undefined;
    setState({...state, hours, minutes, duration});
    if (props.onChange) props.onChange({ hours, minutes, duration });
  };

  const handleMinutesChange = (value) => {
    let hours = state.hours + parseInt((value||0) / 60);
    let minutes = parseInt((value||0) % 60);
    let duration = hours * 60 + minutes;
    if (hours === 0) hours = undefined;
    if (minutes === 0) minutes = undefined;
    setState({...state, hours, minutes, duration});
    if (props.onChange) props.onChange({ hours, minutes, duration });
  };

  return (
    <Fragment>
      <Grid
        container
        direction="row"
        justify="flex-end"
        spacing={1}
      >
        <Grid item xs style={{ width:30 }}>
          <MaskedNumber
            // inputLabelProps={{shrink: true}}
            ignorePropChanges={true}
            value={state.hours}
            valueCap={props.maxHours||48}
            decimalScale={0}
            fixedDecimalScale={true}
            onChange={handleHoursChange}
            style={{fontSize: "0.875rem", ...props.style}}
            suffix=" h"
            placeHolder="Hours"
          />
        </Grid>
        <Grid item xs style={{ width:20 }}>
          <MaskedNumber
            // inputLabelProps={{shrink: true}}
            ignorePropChanges={true}
            value={state.minutes}
            valueCap={59}
            decimalScale={0}
            fixedDecimalScale={true}
            onChange={handleMinutesChange}
            style={{fontSize: "0.875rem", ...props.style}}
            suffix=" m"
            placeHolder="Mins"
          />
        </Grid>
      </Grid>
    </Fragment>
  )
};

export default Duration;